import axiosInstance from '../services/AxiosInstance';

export const getIPAddress = (getData) => {
  return axiosInstance.get("whitelist-Ip/list", {
    params: getData,
  });
};

export const addIPAddress = (data) => {
  return axiosInstance.post("whitelist-Ip/create", data);
};

export const getIPAddressCount = (data) => {
  return axiosInstance.get("whitelist-Ip/details", data);
};

export const updateIPAddress = (id, data) => {
  return axiosInstance.put(`whitelist-Ip/update/${id}`, data);
};

export const fetchIPAddressById = async (id) => {
    const response = await axiosInstance.get(`whitelist-Ip/show/${id}`);
    return response.data;
};
